// Bookkeeper packages are no longer serviced from this portal. Anyone signing
// up for - or already on - a Bookkeeper package is sent to the new Bookkeeper
// Portal instead.
export const BOOKKEEPER_PORTAL_URL = 'https://bookkeeper.finmo.co.uk/auth/';

// Plans that live in the new Bookkeeper Portal - 'Bookkeeper', 'Bookkeeper MTD'
// and 'Bookkeeper Plus'. Only 'Bookkeeper' is listed on the pricing table (see
// planContent); the variants stay hidden, but users already on one of them
// still need sending over to the Bookkeeper Portal.
export const isBookkeeperPlan = (name) =>
  !!name && name.trim().toLowerCase().startsWith('bookkeeper');

export default BOOKKEEPER_PORTAL_URL;
